module.exports = __webpack_public_path__ + "static/img/like_1_1.9ae5523f.svg";